import React from "react";
import DetailsRow from "@/components/molecules/DrawerDetails/DetailsRow";
import dayjs from "dayjs";
import { Order } from "@/types";
import { useTranslation } from "react-i18next";

interface OrderDetailsProps {
  order: Order;
  isLoading: boolean;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ order, isLoading }) => {
  const { t } = useTranslation();
  return (
    <>
      <DetailsRow
        label={"common:created"}
        value={dayjs(order.created).format("DD.MM.YYYY HH:mm")}
        isLoading={isLoading}
      />
      <DetailsRow label={"orders:amountOrdered"} value={`${order.amount} ${order.unit?.unit}`} isLoading={isLoading} />
      <DetailsRow
        label={"orders:orderType"}
        value={t(`enumerables:orderType.${order.orderType.type}`)}
        isLoading={isLoading}
      />
      <DetailsRow
        label={"product:material"}
        value={t(`enumerables:plastic.${order.salesItem?.salesItem}`)}
        isLoading={isLoading}
      />
      <DetailsRow label={"product:format"} value={t(`enumerables:types.${order.type?.type}`)} isLoading={isLoading} />
      <DetailsRow
        label={"product:condition"}
        value={t(`enumerables:conditions.${order.condition?.condition}`)}
        isLoading={isLoading}
      />
      <DetailsRow
        label={"product:boxtype"}
        value={t(`enumerables:boxTypes.${order.packaging?.boxtype.name}`)}
        isLoading={isLoading}
      />
    </>
  );
};

export default OrderDetails;
